import {
    Deferred,
    Instance,
    Objekt,
    Promize,
    Table,
} from '@siposdani87/sui-js';
import { app } from '../app';
import { BudgetService } from '@services/budgetService';
import { ItemService } from '@services/itemService';
import { LanguageService } from '@services/languageService';
import { UserService } from '@services/userService';
import { initTable } from '@utils/collectionSetup';
import { DashboardController } from './dashboardController';

export class ItemsIndexController extends DashboardController {
    static readonly inject = [
        'instances',
        'itemService',
        'budgetService',
        'userService',
        'languageService',
    ] as const;

    budgetId!: string;
    categoryId!: string;
    budget!: Objekt;
    organizationId!: string;
    itemsTable!: Table;

    constructor(
        instances: Instance,
        private itemService: ItemService,
        private budgetService: BudgetService,
        private userService: UserService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initLayout(): void {
        this.budgetId = this.state.getParam('budgetId');
        this.categoryId = this.state.getParam('categoryId');

        this._initToolbarButtons();

        this._loadBudget().then(() => {
            this._drawContent();
        });
    }

    private _loadBudget(): Promize {
        const deferred = new Deferred();
        this.budgetService
            .get(this.budgetId, {
                fields: 'id,name,organization_id',
            })
            .then(
                (response) => {
                    this.budget = response.get<Objekt>('budget');
                    this.organizationId = this.budget.get<string>('organization_id');
                    deferred.resolve();
                },
                () => {
                    deferred.reject();
                },
            );
        return deferred.promise();
    }

    protected override _drawContent(): Promize | boolean {
        this._initItemTable();
        return true;
    }

    private _initToolbarButtons(): void {
        this.helper.iconButton('.btn-budgets-show', this.dom, () => {
            this.state.goBack('budgets.show', {
                budgetId: this.budgetId,
            });
        });

        this.helper.fabButton('.btn-items-new', this.dom, () => {
            this.itemService.newDialogByBudget(this.budgetId).then(() => {
                this.state.refresh(true);
            });
        });
    }

    private _initItemTable(): void {
        this.itemsTable = initTable(
            this.itemsTable,
            this.dom,
            '.items-table',
            this.itemService,
            {
                entityKey: 'items',
                fetchData: (params) =>
                    this.itemService.getAllByBudgetAndCategory(
                        this.budgetId,
                        this.categoryId,
                        params,
                    ),
            },
            [
                {
                    style: (item) => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                            false,
                            !this.userService.hasAccessByOrganization(
                                this.organizationId,
                                'items_write',
                            ),
                        ];
                    },
                    click: (item) => {
                        this.itemService.editDialog(item).then(() => {
                            this.state.refresh(true);
                        });
                    },
                },
            ],
        )!;
    }
}

export const itemsIndexController = app.controller(
    'itemsIndexController',
    ItemsIndexController,
);
